// extracted by mini-css-extract-plugin
export default {"root":"fYKE2v","breadcrumb":"PVM3fu","sibling":"bzSsl3","previousPageBreadcrumb":"BnoF00","arrow":"rk2sLg"};